import React, { useState, useEffect } from 'react';
import './PersonalInfo.css'; 

// Mock data for demonstration
const mockData = {
  firstName: 'ABC',
  lastName: 'ABC',
  dob: '2000-02-24',
  gender: 'male',
  contact: 'ABC',
  email: 'ABC',
  nationality: 'usa',
  passportNo: 'ABC123'
};

const PersonalInfo = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    gender: '',
    contact: '',
    email: '',
    nationality: '',
    passportNo: ''
  });
  
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    setIsLoading(true);
    try {
      // Simulating API call with setTimeout
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // In a real application, you would fetch data from your API
      // const response = await fetch('/api/user-info');
      // const data = await response.json();
      
      setFormData(mockData);
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      // Simulating API call with setTimeout
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // In a real application, you would send data to your API
      // await fetch('/api/user-info', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(formData)
      // });
      
      console.log('Updated Data:', formData);
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  return (
    <>
    <div style={{fontWeight:'500',fontSize:'250%'}}>Personal Info</div>
    <div className="personal-info-container">
      <div className="personal-info-form-container">
        <div className="personal-info-input-group">
          <label>First Name</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          />
        </div>

        <div className="personal-info-input-group">
          <label>Last Name</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          />
        </div>

        <div className="personal-info-input-group">
          <label>Date of Birth</label>
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          />
        </div>

        <div className="personal-info-input-group-select">
          <label>Gender</label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          >
            <option value="">Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="personal-info-input-group">
          <label>Contact</label>
          <input
            type="text"
            name="contact"
            value={formData.contact}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          />
        </div>

        <div className="personal-info-input-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          />
        </div>

        <div className="personal-info-input-group-select">
          <label>Nationality</label>
          <select
            name="nationality"
            value={formData.nationality}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          >
            <option value="">Select</option>
            <option value="usa">United States</option>
            <option value="uk">United Kingdom</option>
            <option value="canada">Canada</option>
            <option value="australia">Australia</option>
          </select>
        </div>

        <div className="personal-info-input-group">
          <label>Passport No.</label>
          <input
            type="text"
            name="passportNo"
            value={formData.passportNo}
            onChange={handleInputChange}
            disabled={!isEditing || isLoading}
          />
        </div>
        <div className="personal-info-button-group">
        {!isEditing ? (
          <button onClick={handleEdit} disabled={isLoading}>
            Edit Details
          </button>
        ) : (
          <button onClick={handleUpdate} disabled={isLoading}>
            Update
          </button>
        )}
      </div>
      </div>
      

    </div>
    </>
  );
};

export default PersonalInfo;
